import { render, staticRenderFns } from "./categoryUpdate.vue?vue&type=template&id=1d6fa1c3&scoped=true"
import script from "./categoryUpdate.vue?vue&type=script&lang=js"
export * from "./categoryUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6fa1c3",
  null
  
)

export default component.exports